<template>
  <div class="app-type_aty" :class="{ 'aty_show-icon': options.showIcon }">

    <input-title :required="options.required" :description="options.description"/>

    <div
        v-if="types.length"
        class="input-groups">

      <div
        v-for="(value, i) in valueLocal"
        :key="'input-group-' + i"
        @click="removeError(i)"
        class="input-group">

        <div
          v-if="value"
          class="aty_cur-icon-wrap">
          <img
            v-if="value"
            class="aty_cur-icon"
            :src="`/static/grx/icons/objects/${value}.svg`">
        </div>

        <el-select
          v-model="valueLocal[i]"
          :key="'input-' + i"
          clearable
          @change="onChange"
          class="aty_options"
          :class="{ 'aty_options--margin': value }"
          v-bind="widgetOptions">
          <el-option
            v-for="(t, i) in types"
            class="aty_option"
            :key="'option-' + i"
            :label="t.label"
            :value="t.value">
            <span class="aty_icon-wrap">
              <img
                class="aty_icon"
                :src="`/static/grx/icons/objects/${t.value}.svg`">
            </span>
            <span class="aty_text">{{ t.label }}</span>
          </el-option>
        </el-select>

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
// import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
    };
  },

  created() {
    // Process local options for this widget type
    this.widgetOptions.placeholder = this.options.placeholder ?
      this.options.placeholder : 'Выберите тип объекта...';
  },

  computed: {

    types() {
      const types = this.$store.getters['types/getTypes'];
      const typesProcessed = [];
      types.forEach((el) => {
        typesProcessed.push({
          value: el.Type,
          label: el.Title,
        });
      });
      return typesProcessed;
    },

  },

  methods: {
    onChange(val) {
      this.$emit('change', val);
    },
  },

};
</script>

<style lang="scss">
.app-type_aty {
  &.aty_show-icon {
    .aty_cur-icon-wrap {
      display: block;
    }
    .aty_options {
      padding-left: 0;
      &.aty_options--margin {
        padding-left: 55px;
      }
    }
  }
}
.aty_cur-icon-wrap {
  height: 40px;
  width: 40px;
  margin-bottom: -40px;
  display: none;
}
.aty_cur-icon {
  height: 40px;
}
.aty_option {
  position: relative;
}
.aty_icon-wrap {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  margin: 0 10px 0 0;
  vertical-align: middle;
  .aty_icon {
    height: 30px;
    width: auto;
  }
}
.aty_text {
  display: block;
  position: absolute;
  top: 50%;
  left: 60px;
  transform: translateY(-70%);
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppType.vue